

export const darkTheme = {
  colors: {
    ui: "#0079FF",
    text: "#fff",
    body: "#141D2F",
    component: "#1E2A47",
    secondaryText:"#fff"
  },
};